import { useEffect, useState } from 'react'

const useLocalStorage = <T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  const [value, setValue] = useState<T>(() => {
    const storedValue = localStorage.getItem(key)
    try {
      return storedValue ? JSON.parse(storedValue) : initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  })

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  useEffect(() => {
    const listenLocalStorage = (event: StorageEvent) => {
      if (event.key === key) {
        setValue(JSON.parse(event.newValue ?? '{}'))
      }
    }
    window.addEventListener('storage', listenLocalStorage)
    return () => window.removeEventListener('storage', listenLocalStorage)
  }, [key])

  return [value, setValue]
}

export default useLocalStorage
